import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { CpmCard, CpmPageShell, CpmTabBar } from '../../components/design-system';
import { REPORTS_COPY } from './copy';
import BrandsBody from './Brands/BrandsBody';
import CatalogBody from './Catalog/CatalogBody';
import TemplatesBody from './Templates/TemplatesBody';

type Place = 'catalog' | 'templates' | 'brands';

function placeFromParam(value?: string): Place | null {
    if (value === 'catalog' || value === 'templates' || value === 'brands') return value;
    return null;
}

export default function Reports() {
    const { place } = useParams<{ place?: string }>();
    const navigate = useNavigate();
    const tab = placeFromParam(place);

    if (!tab) {
        return <Navigate to="/reports/catalog" replace />;
    }

    return (
        <CpmPageShell gap={20} maxWidth={1440} variant="compactBottom">
            <h1
                className="m-0"
                style={{
                    fontSize: 30,
                    fontWeight: 800,
                    letterSpacing: '-0.025em',
                    color: 'var(--cpm-text-primary)',
                }}
            >
                {REPORTS_COPY.TITLE}
            </h1>
            <CpmCard>
                <CpmTabBar
                    value={tab}
                    onChange={(next) => navigate(`/reports/${next}`)}
                    tabs={[
                        { value: 'catalog', label: REPORTS_COPY.TAB_CATALOGUE },
                        { value: 'templates', label: REPORTS_COPY.TAB_TEMPLATES },
                        { value: 'brands', label: REPORTS_COPY.TAB_STORE_BRANDS },
                    ]}
                />
                {tab === 'catalog' ? <CatalogBody /> : null}
                {tab === 'templates' ? <TemplatesBody /> : null}
                {tab === 'brands' ? <BrandsBody /> : null}
            </CpmCard>
        </CpmPageShell>
    );
}
